import React from 'react';

const ErrorState = ({ message }) => (
    <div className="rounded-xl border border-red-100 bg-red-50 px-4 py-3 text-red-700 text-sm">
        {message || 'Something went wrong.'}
    </div>
);

export default ErrorState;
